import firstAdmissionService from "@/services/FirstAdmission";

/**
 * Crea y asocia el @ID a la cuenta de forma silenciosa: pide las opciones de
 * imagen/palabra de seguridad y elige una combinación al azar. El @ID es de
 * uso interno, la persona usuaria no interviene.
 * Nunca lanza: devuelve el @id creado o null si algo falla, para que quien
 * llame deje entrar al home igualmente.
 */
export async function autoAssociateArrobaId() {
  try {
    const options = await firstAdmissionService.getImageAndWordToConfirmation();
    const images = options?.securityImages || [];
    const words = options?.securityWord || [];
    if (!images.length || !words.length) return null;

    const image = images[Math.floor(Math.random() * images.length)].id;
    const word = words[Math.floor(Math.random() * words.length)].id;
    const result = await firstAdmissionService.firstLogin({ image, word });
    return (result && result["@id"]) || null;
  } catch (error) {
    console.error("Error asociando el @ID automáticamente:", error);
    return null;
  }
}
